import { render } from "./UserOverview.vue?vue&type=template&id=e057166e"
import script from "./UserOverview.vue?vue&type=script&lang=js"
export * from "./UserOverview.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\lis-ticket-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__